<template>
    <div style="padding: 20px;">
      <span style="font-weight: bold;font-size: 22px;float: left">全国大学生态环境管理科研创新大赛平台使用说明</span>
      <p style="height: 30px"></p>
      <hr>
      <div class="markdown-body" v-html="html"></div>
    </div>
</template>

<script>
  import mdContent from '@/assets/instruction.md'
  import MarkdownIt from 'markdown-it'
  export default {
    name: "instruction",
    data() {
      return {
        html: ''
      }
    },

    methods: {
      load() {
        const imagesContext = require.context('@/assets/instruction_images/',true,/\.(png|jpe?g|gif|svg)$/)
        const md = new MarkdownIt({
          html: true,
          linkify: true,
          typographer: true
        })
        const fixedMd = mdContent.replace(/!\[(.*?)\]\((.*?)\)/g,
          (match, alt, src) => {
            if (/^(http|https|\/)/.test(src)){
              return match
            }
            return `![${alt}](${imagesContext('./' + src)})`
          }
        )

        this.html = md.render(fixedMd)
      }
    },

    created() {
      this.load()
    }
  }

</script>
<style scoped>
  .markdown-body{
    text-align:left;
  }
  h1{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/page/Admin/Instruction.vue